import React__default from 'react';
import cn from 'classnames';
import { icons } from './components/index.js';
export { icons } from './components/index.js';

const Icon = /*#__PURE__*/React__default.forwardRef(function Icon(props, ref) {
  var _props$className;

  const {
    name,
    ...otherProps
  } = props;
  const Component = icons[name];
  /* 24x24 _at the base body font_ - must be em so that they scale with font size - tailwind spacing uses rem */

  const className = cn('inline-flex h-[1.715em] w-[1.715em] flex-shrink-0', props.className, {
    'p-[3px]': (_props$className = props.className) === null || _props$className === void 0 ? void 0 : _props$className.includes('rounded-full')
  });
  return Component ? React__default.createElement(Component, Object.assign({}, otherProps, {
    className: className,
    "data-taco": "icon",
    focusable: "false",
    ref: ref,
    role: "img"
  })) : null;
});

export { Icon };
//# sourceMappingURL=Icon.js.map
